import script from "./WidgetMultiVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetMultiVideo.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetMultiVideo.vue?vue&type=style&index=0&id=c355f522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c355f522"]])

export default __exports__